var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEventHandlers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.28912 8.125H2.5V5C2.5 4.83421 2.56592 4.67529 2.68311 4.55803C2.80029 4.44084 2.95929 4.375 3.125 4.375H7.28912C7.42416 4.37553 7.55554 4.41933 7.66403 4.49997L10 6.25L7.66403 8.00003C7.55554 8.08067 7.42416 8.12447 7.28912 8.125Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 15.625V8.125C3.125 7.77982 2.84518 7.5 2.5 7.5C2.15482 7.5 1.875 7.77982 1.875 8.125V15.625C1.875 16.1428 2.24112 16.5089 2.24112 16.5089C2.60723 16.875 3.125 16.875 3.125 16.875H16.875C17.3928 16.875 17.7589 16.5089 17.7589 16.5089C18.125 16.1428 18.125 15.625 18.125 15.625V6.875C18.125 6.35723 17.7589 5.99112 17.7589 5.99112C17.3928 5.625 16.875 5.625 16.875 5.625H10C9.65482 5.625 9.375 5.90482 9.375 6.25C9.375 6.59518 9.65482 6.875 10 6.875H16.875V15.625H3.125Z",
    fill: "#D6D6D6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.037 8.50154C8.037 8.50154 7.70541 8.74811 7.29225 8.74999L7.29165 8.74999L7.28906 8.75H2.5C2.15482 8.75 1.875 8.47018 1.875 8.125V5C1.875 5 1.875 4.48223 2.24112 4.11612C2.24112 4.11612 2.60723 3.75 3.125 3.75L7.29163 3.75001C7.29163 3.75001 7.70516 3.75171 8.03879 3.9998L10.3747 5.7498C10.4223 5.78544 10.4646 5.82769 10.5002 5.87527C10.5996 6.00793 10.6422 6.17464 10.6187 6.33872C10.5951 6.5028 10.5074 6.65082 10.3747 6.7502L8.037 8.50154ZM7.28676 7.5C7.28676 7.5 7.28917 7.49991 7.29112 7.49846L8.95759 6.25L7.28933 5.0002C7.28933 5.0002 7.28906 5.00001 7.28649 4.99999L3.125 5V7.5H7.28676Z",
    fill: "#D6D6D6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventHandlers);
export default __webpack_public_path__ + "static/media/eventHandlers.c6c8abd7382e3a0b0d4beb49673c1f95.svg";
export { ForwardRef as ReactComponent };